import { required } from "ra-core";
import { useWatch } from "react-hook-form";
import { DateInput } from "@/components/admin/date-input";
import { FileField } from "@/components/admin/file-field";
import { FileInput } from "@/components/admin/file-input";
import { NumberInput } from "@/components/admin/number-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { transactionDirectionChoices } from "../shared/transactionModel";

export const TransactionInputs = () => {
  const direction = useWatch({ name: "direction" });
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <SelectInput
        source="direction"
        choices={transactionDirectionChoices}
        validate={required()}
        helperText={false}
      />
      <NumberInput
        source="amount"
        validate={required()}
        helperText={false}
        min={1}
      />
      <ReferenceInput source="account_id" reference="accounts">
        <AutocompleteInput
          label="resources.transactions.fields.account_id"
          validate={required()}
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput
        source="category_id"
        reference="transaction_categories"
        filter={direction ? { direction } : undefined}
      >
        <AutocompleteInput
          label="resources.transactions.fields.category_id"
          helperText={false}
        />
      </ReferenceInput>
      <DateInput source="occurred_at" validate={required()} helperText={false} />
      <ReferenceInput source="contract_id" reference="contracts">
        <AutocompleteInput
          label="resources.transactions.fields.contract_id"
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput source="company_id" reference="companies">
        <AutocompleteInput
          label="resources.transactions.fields.company_id"
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput source="deal_id" reference="deals">
        <AutocompleteInput
          label="resources.transactions.fields.deal_id"
          helperText={false}
        />
      </ReferenceInput>
      <TextInput
        source="description"
        multiline
        rows={2}
        className="md:col-span-2"
        helperText={false}
      />
      <div className="md:col-span-2">
        <FileInput
          source="attachments"
          label="resources.transactions.fields.attachments"
          multiple
        >
          <FileField
            source="src"
            title="title"
            target="_blank"
            className="[&_a]:text-blue-600 [&_a]:hover:text-blue-800 [&_a]:underline [&_a]:break-all"
          />
        </FileInput>
      </div>
    </div>
  );
};
